<template src='./newClassificationCriteria.pug' lang='pug'></template>

<script>
import vSelect from 'vue-select'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import ConciliationField from './ConciliationField'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'

export default {
  name: 'NewClassificationCriteria',

  components: {
    vSelect,
    PageTitle,
    FilterPortlet,
    ConciliationField,
    ButtonPrimary
  },

  props: {
    criteriaToEdit: {
      type: Object,
      default: null
    },
    categories: {
      type: Array,
      default: null,
      required: true
    },
    febraban: {
      type: Array,
      default: null,
      required: true
    },
    banks: {
      type: Array,
      default: null,
      required: true
    },
    accounts: {
      type: Array,
      default: null,
      required: true
    },
    attributesCfg: {
      type: Array,
      default: null,
      required: true
    },
    conciliationFields: {
      type: Array,
      default: null,
      required: true
    }
  },

  data () {
    return {
      requestSent: false,
      criteria: {},
      filteredAccounts: [],
      attributes: []
    }
  },

  watch: {
    criteriaToEdit: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.criteria = {...newVal, classificacaoCampos: [...newVal.classificacaoCampos]}
          if (this.criteria.categoria) {
            this.criteria.categoria.label = this.criteria.categoria.numero + ' - ' + this.criteria.categoria.nome
          }
          if (this.criteria.conta) {
            this.criteria.conta.label = this.criteria.conta.id !== 0 ? (this.criteria.conta.nome + ' (' +
              this.criteria.conta.numAgencia + (this.criteria.conta.digAgencia ? ('-' + this.criteria.conta.digAgencia) : '') +
              '/' +
              this.criteria.conta.conta + (this.criteria.conta.digConta ? ('-' + this.criteria.conta.digConta) : '') +
              ')' +
              (this.criteria.conta.ativo === undefined || this.criteria.conta.ativo === null || this.criteria.conta.ativo ? '' : (' [' + this.$t('contaBancaria.labels.inativa') + ']')))
              : this.criteria.conta.nome
          }

          if (this.criteria.banco) {
            this.criteria.banco.label = (this.criteria.banco.codigo ? this.criteria.banco.codigo + '-' : '') + this.criteria.banco.nomeFantasia
          }

          if (this.criteria.categoriaFebraban) {
            this.criteria.categoriaFebraban.label = this.criteria.categoriaFebraban.codigo + ' - ' + this.criteria.categoriaFebraban.descricao
          }
        } else {
          this.criteria = {
            ativo: true,
            relevante: true,
            banco: {},
            conta: {},
            categoria: {},
            categoriaFebraban: {},
            classificacaoCampos: [],
            criterioEmUso: false
          }
        }
      }
    },
    accounts: {
      handler (newVal, oldVal) {
        this.filteredAccounts = [...newVal]
      }
    }
  },

  methods: {
    filterAccounts (val) {
      this.criteria.conta = null
      if (val && val.codigo) {
        this.criteria.banco = val
        this.filteredAccounts = this.accounts.filter(account => {
          return account.banco.codigo === val.codigo || account.id === 0
        })
      } else {
        this.criteria.banco = null
        this.filteredAccounts = [...this.accounts]
      }
    },

    back () {
      this.$emit('change-managing-plan')
      this.errors.clear()
      this.requestSent = false
    },

    validate (event) {
      this.requestSent = true
      let self = this
      event.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          let isAllFieldsValid = true
          Object.entries(self.$refs).map(refArray => {
            if (refArray[1] && refArray[1].length > 0) {
              refArray[1][0].$validator.validateAll().then((fieldValidation) => {
                if (isAllFieldsValid) {
                  isAllFieldsValid = fieldValidation
                }
              })
            }
          })
          setTimeout(() => {
            if (isAllFieldsValid) {
              self.addCriteria()
            } else {
              this.requestSent = false
            }
          }, 500)
        } else {
          this.requestSent = false
        }
      })
    },

    addCriteria () {
      this.$emit('add-criteria-to-plan', this.criteria)
      this.back()
    },

    setValuesFieldsCategory (category) {
      if (category) {
        this.criteria.tipoLancamento = category.tipo
        if (!this.criteria.hasOwnProperty('descricao') || this.criteria.descricao === '') {
          this.$set(this.criteria, 'descricao', category.nome)
          const field = this.$validator.fields.find({name: 'criteria.descricao'})
          field.reset()
          this.$validator.errors.remove(field.name)
        }
      } else {
        this.criteria.categoria = null
        this.criteria.tipoLancamento = null
      }
    },

    addClassificationField () {
      if (!this.criteria.classificacaoCampos) {
        this.criteria.classificacaoCampos = []
      }

      this.criteria.classificacaoCampos.push({
        idCriterioClassificacao: this.criteria.idCriterioClassificacao,
        idAtributoCfg: this.attributesCfg[0],
        nomeAtributo: this.attributesCfg[0].children[0],
        conciliacaoCampo: this.conciliationFields[0],
        key: this.criteria.classificacaoCampos.length + 1
      })
    },

    removeClassificationField (field) {
      const index = this.criteria.classificacaoCampos.findIndex(item => item.key === field.key)
      this.criteria.classificacaoCampos.splice(index, 1)
      if (field.id) {
        if (!this.criteria.idsCamposRemovidos) {
          this.criteria.idsCamposRemovidos = []
        }
        this.criteria.idsCamposRemovidos.push(field.id)
      }
    },

    changeFieldAttCfg (item) {
      this.criteria.classificacaoCampos.map(mappedItem => {
        // identifica a configuracao alterada
        if (mappedItem.key === item.concField.key) {
          // atualiza campo
          mappedItem.idAtributoCfg = item.cfg
          if (item.cfg) {
            // atualiza lista de atributos com os filhos do conjunto
            this.attributes = item.cfg.children
            let att = item.cfg.children.find(itemAtt => itemAtt.id === (mappedItem.nomeAtributo instanceof Object ? mappedItem.nomeAtributo.id : mappedItem.nomeAtributo))
            mappedItem.nomeAtributo = att !== null && att !== undefined ? att : item.cfg.children[0]
          } else {
            mappedItem.nomeAtributo = null
            this.attributes = []
          }
        }
      })
    },

    changeFieldAttName (item) {
      this.criteria.classificacaoCampos.map(mappedItem => {
        // identifica a configuracao
        if (mappedItem.key === item.concField.key) {
          // atualiza campo
          mappedItem.nomeAtributo = item.att
        }
      })
    },

    changeFieldAttConciliationField (item) {
      this.criteria.classificacaoCampos.map(mappedItem => {
        // identifica a configuracao
        if (mappedItem.key === item.concField.key) {
          // atualiza campo
          mappedItem.conciliacaoCampo = item.field
        }
      })
    }
  }
}
</script>

<style scoped>
.marged-button {
  margin-left: 10px;
}

.alert-icon {
  margin-right: 10px;
  color: red;
  font-size: 20px;
}

.alert-text {
  color: red;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// NewClassificationCriteria.vue?4d338515